import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-contract-information',
    templateUrl: './contract-information.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContractInformationComponent {

}
